/** Auth0 返回 authorization code 或错误时，页面不应抢先启动其它登录交互。 */
export function isHandlingAuth0Response(search: string): boolean {
  const params = new URLSearchParams(search);
  return (
    (params.has('code') && params.has('state')) ||
    params.has('error') ||
    params.has('error_description')
  );
}
